<template>
	<el-dropdown trigger="hover" placement="top-start">
		<div class="head-img">
			<img v-if="user.avatarUrl" :src="user.avatarUrl" />
		</div>
		<el-dropdown-menu slot="dropdown" class="header-dropdown">
			<div class="user_info">
				<img v-if="user.avatarUrl" class="user_avatar" :src="user.avatarUrl" />
				<div class="info">
					<div class="nickname">{{ nickname }}</div>
					<div class="username">{{ user.areaCode }} {{ maskedPhone }}</div>
				</div>
			</div>
			<div class="operate_wrap">
				<el-dropdown-item
					class="dropdown_hover"
					@click.native="goUserCenter('/user/account')"
				>
					<div class="operate">
						<i class="iconfont icon-zhanghaozhongxin"></i>
						账号中心
					</div>
				</el-dropdown-item>
				<el-dropdown-item
					class="dropdown_hover"
					@click.native="goUserCenter('/user/safeSetting')"
				>
					<div class="operate">
						<i class="iconfont icon-anquanshezhi-01"></i>
						安全设置
					</div>
				</el-dropdown-item>
			</div>
			<el-button style="width: 100%" @click.native="logoutHandle">
				<i class="iconfont icon-tuichudenglu-01"></i>
				退出登录
			</el-button>
		</el-dropdown-menu>
	</el-dropdown>
</template>

<script>
import { mapState } from 'vuex';
import config from '@/config';
import { user, errors, login } from '@/services/indexnew';

export default {
	computed: {
		...mapState({
			user: (state) => state.user.userInfo,
		}),
		nickname() {
			return this.user.nickname ? this.user.nickname : this.username;
		},
		username() {
			const username = this.user.username ? this.user.username : '';
			return username;
		},
		maskedPhone() {
			const phone = this.user.mobPhone || '';
			return phone.replace(/(\d{3})\d{4}(\d{1})/, '$1****$2');
		},
	},
	methods: {
		logoutHandle() {
			this.$confirm('确认退出吗?', '提示')
				.then(async () => {
					try {
						const { data, ok } = await user.logout();
						if (!ok) {
							return;
						}
						sessionStorage.clear();
						login();
					} catch (e) {
						errors(e);
					}
				})
				.catch(() => {});
		},
		goUserCenter(link) {
			let uri = `${config.ssoPath}${link}`;
			window.open(uri, '_blank');
		},
	},
};
</script>

<style lang="less">
.head-img {
	width: 32px;
	height: 32px;
	border-radius: 50%;
	overflow: hidden;
	cursor: pointer;
	img {
		width: 100%;
		height: 100%;
	}
}
.header-dropdown {
	width: 232px;
	padding: 24px 16px;
	.user_info {
		width: 100%;
		box-sizing: border-box;
		padding-bottom: 16px;
		display: flex;
		flex-flow: row nowrap;
		align-items: center;
		.user_avatar {
			margin-right: 16px;
			width: 48px;
			height: 48px;
			border-radius: 50%;
			display: block;
		}
		.info {
			width: 10px;
			flex-grow: 1;
		}
		.nickname {
			font-size: 16px;
			color: #1d2129;
			font-weight: 500;
			line-height: 24px;
			word-break: break-all;
			word-wrap: break-word;
			white-space: normal;
		}
		.username {
			margin-top: 4px;
			font-size: 14px;
			line-height: 22px;
			color: #969799;
			word-break: break-all;
			word-wrap: break-word;
			white-space: normal;
		}
		.tags {
			display: flex;
			margin-top: 8px;
			.account_tag {
				padding: 0 6px;
				font-size: 12px;
				height: 20px;
				line-height: 20px;
				border-radius: 2px;
				[class^='el-icon-'] {
					margin-right: 4px;
				}
				& + .account_tag {
					margin-left: 8px;
				}
			}
		}
	}
	.el-dropdown-menu__item {
		padding: 0;
		margin: 0;
		line-height: 1;
		&::before {
			display: none;
		}
	}
	.dropdown_hover:hover {
		background-color: #f7f8fa !important;
	}
	.operate_wrap {
		box-sizing: border-box;
		width: 100%;
		padding: 16px 0;
		border-top: 1px solid #e5e6eb;
	}
	.operate {
		box-sizing: border-box;
		padding: 10px 8px;
		display: flex;
		flex-flow: row nowrap;
		align-items: center;
		font-size: 14px;
		color: #1d2129;
		.iconfont {
			margin-right: 8px;
			font-size: 18px;
			width: 18px;
			height: 18px;
			color: #4e5969;
			line-height: 1;
		}
		.tag {
			background-color: #ffece8;
			color: #f53f3f;
			margin-left: 8px;
			border-radius: 2px;
			padding: 4px 8px;
		}
	}
	.el-button:hover {
		color: #1d2129;
		border-color: #dcdfe6;
		background-color: #f7f8fa;
	}
	.user_capacity {
		width: 100%;
		box-sizing: border-box;
		padding: 16px 0;
	}
}
</style>
